import React, { Component } from 'react';
import HomePanel from '../HomePanel';
import {withRouter} from 'react-router-dom';
import { isUserLoggedIn } from '../../service/UserService';
import {Helmet} from "react-helmet";

class ItemPage6 extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    register(id){
        if(isUserLoggedIn()){
            this.props.history.push("/termekregisztracio?termek="+id);
        }
        else{
            this.props.history.push("/regisztracio");
        }
    }
    render() { 
        return ( 
            <div className="kwizda-itempage-container">
                <Helmet>
                    <meta 
                        name="title"
                        content="Leander virágzásnövelési kísérlet"
                    />
                    <meta name="description" content="Leander virágzásnövelési kísérlet" />
                    <meta name="keywords" content="nagy termés, kötődés, terméskötődés, termés növelés, biostimulátor, foszfor, bór, alga, paradicsom, biológiai, tesztelje ingyen, regisztráció, biológiai, biológiai gazdálkodás" />
                </Helmet>
                <div className="kwizda-itempage">
                    <h2>Leander virágzásnövelési kísérlet</h2>
                    <div>
                        <br/>A kísérlet témája az egy komponensű Amazon mikrobiológiai készítmény és egy baktériumkeverék hatásának vizsgálata a leander virághozamára és hajtásfejlődésére. 
                        <br/>A leander az egyik leggyakrabban ültetett dézsás virágzó cserje a díszkertekben.  A virágzás intenzitása és a hajtások növekedése fokozható mikrobiológiai készítményekkel. Most összehasonlítjuk egy elterjedt baktériumkeverék és a legmodernebb mikrobiológiai készítményünk, az Amazonnal hatását a leander virág- és hajtásfejlődésére.
                        <br/>
                        <b>A kísérlet lényege, hogy nyomon követjük a virághozam és hajtásnövekedés változásait, ezt fotókkal dokumentáljuk, kiértékeljük és megosztjuk.</b>
                    </div>
                    <h3>Szakmai feltételek:</h3>
                    <div style={{marginTop:30}}>
                        Az „on-garden” kísérletben 1 db Amazon 100 g mikrobiológiai készítményt és 100 ml  baktériumkeveréket küldünk ki a résztvevőknek.
                        <br/>A kísérletben 2 db egymáshoz nagyon hasonló, 100-150 cm magasságú leandernek kell szerepelnie.
                        <br/>A növények sem előtte, sem a kísérlet időszaka alatt más tápanyagot nem kaphatnak.
                        <br/>A kísérlet május elsején permetezéssel kezdődik és június 30-án, fotózással ér véget.
                        <br/>Az <b>A növényt</b> 20g/10 liter víz dózisú Amazon permetszerrel 2 hetente, összesen 3 alkalommal kell lepermetezni alaposan, 
                        A <b>B növényt</b> ugyanezen időpontokban be kell öntözni a baktériumkeverék 1%-os oldatával . 
                        <br/>Fontos, hogy az Amazonos kezelések után 6 órán keresztül ne mossa le sem öntözővíz, sem eső a mikrobiológiai készítményt.
                        <br/>A két növénynek legalább 5 méterre kell lenni egymástól, a beszóródás megakadályozására. Figyelni kell, hogy a környezeti tényezők továbbra is megegyezzenek (benapozottság, vízellátás)
                        <br/>Semmilyen más tápanyagot nem kaphatnak, sem műtrágyát, sem lombtrágyát, sem házi készítményeket (csalánlé, komposzt, stb.).
                        <br/>Rovarok elleni kezelést (kén kivételével) szükség esetén kaphatnak, gombák ellenit nem. Fontos, hogy a kezelések mindig egyezőek legyenek a két növényen azonosan és feljegyzésre kerüljenek.
                        <br/>A kísérlet akkor minősül sikeresnek, ha minden kezelést és fotózást a kért módon elvégeztek.
                        <br/>A kísérlet meghiúsulása esetén nem küldünk a leírásban szereplő ajándékot.
                    </div>
                    <h3>Dokumentációs feltételek:</h3>
                    <div style={{marginTop:30}}>
                        Az első kezeléstől a következő időszakonként kérünk dokumentáló fotókat.
                        <br/>
                        <br/><b>1. fotó:</b> Kiindulási állapot. 
                        <br/>&nbsp;&nbsp;Az A növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>&nbsp;&nbsp;A B növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>
                        <br/><b>2. fotó:</b> 2 héttel később ugyanabban a szögben és távolságról kérünk ugyanazokról 
                        <br/>&nbsp;&nbsp;Az A növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>&nbsp;&nbsp;A B növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>
                        <br/><b>3. fotó:</b> 2 héttel később ugyanabban a szögben és távolságról kérünk ugyanazokról 
                        <br/>&nbsp;&nbsp;Az A növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>&nbsp;&nbsp;A B növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>
                        <br/><b>4. fotó:</b> 2 héttel később ugyanabban a szögben és távolságról kérünk ugyanazokról 
                        <br/>&nbsp;&nbsp;Az A növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>&nbsp;&nbsp;A B növényről 3 db kiválasztott hajtást tartalmazó kép közelről.
                        <br/>
                        <br/>A fotók küldése során legyen egyértelműen feltüntetve, melyik az A növény fotója és melyik a B növény fotója!
                        <br/>A fotókat minden héten hétfőn reggel 8-ig kérjük emailben megküldeni a <a className='kwizda3-link' href='mailto:marketing@muchmore.hu'>marketing@muchmore.hu</a> email címre.

                        <div style={{marginTop:30}}>
                            <img alt="cimke" style={{display:'inline-block', width:'25%'}} src="img/kwizda3_cimkek/nezzuk_kiserletek_thumbnail_web_leandervirag.png"></img>
                            <img alt="kepseged" style={{display:'inline-block', width:'75%'}} src="img/kwizda3_fotoseged/web_leander_kepseged.png"></img>
                        </div>
                    </div>
                    <h3>Nevezési feltételek:</h3>
                    <div>
                        Regisztráció a nezzukbioban.hu oldalon
                        <br/><b>Itt meg kell adni az elérhetőséget és a kísérlet helyét.</b>
                        <br/><b>Kérünk fotót a komposztálókról és közvetlen környezetükről.</b>
                        <br/>A jelentkezők közül 6 kertészt választunk ki. A döntésnél a kísérletben szereplő komposztálók átláthatóságát, méretét vesszük figyelembe.
                        <br/>
                        <br/><b>A kiválasztott kertészeket emailben értesítjük.</b>
                        <br/>
                        <br/><b>Garantált nyeremény egy sikeresen dokumentált kísérlet után:</b>
                        <ul>
                            <li>1 db 100g-os Amazon mikrobiológiai készítmény</li>
                        </ul>
                        <br/>A kísérlet akkor értékelhető sikeresnek, ha a kezelések megtörténtek, a kész komposztok kitermelésre kerültek és minden héten megkapjuk a kért minőségű fotókat.
                        <br/>Ebben az esetben az ajándékokat a kísérlet befejeződése utáni két héten belül postán küldjük meg a résztvevőknek a regisztráció során megadott címre.
                        <br/>
                        <br/><b>Tartson velünk! </b>
                        <br/><b>Nézzük együtt milyen hatással vannak a komposztálásra a baktériumkeverékek és a specializált, egykomponensű AGRIN baktériumkészítmény!</b>
                    </div>
                    <br/>
                    <div className="kwizda-itempage-table-div">
                            <table className="kwizda-itempage-table">
                                <thead>
                                    <tr>
                                        <th>Nevezési határidő:</th>
                                        <th>Kísérlet megvalósítás időzítése: </th>
                                        <th>Megvalósítás helye: </th>
                                        <th>Helyszínek száma:</th>
                                        <th>Dokumentáció módja:</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>2025. 05. 15.</td>
                                        <td>2025 06 hóban</td>
                                        <td>Szabadföld kertben</td>
                                        <td>Maximum 6 helyszínen</td>
                                        <td>Fotó küldése emailcímre</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                </div>
                <br/>
                <HomePanel isItemPage={true} register={()=>this.register(6)}></HomePanel>
            </div>
         );
    }
}

export default withRouter(ItemPage6);